import React, { useEffect, useState } from 'react'
import { CForm, CFormInput, CFormLabel, CRow } from '@coreui/react'
import { Button } from '@mui/material'
import { Dialog } from 'primereact/dialog'
import { Calendar } from 'primereact/calendar'
import { useUser } from '../contexts/UserContext'
import { useAuth } from '../contexts/AuthContext'

function AddUserShift({ visible, editMode, editShiftId, handleClose, userName, fetchLabourReport, userId }) {
    const { createUserShift, updateUserShift, getSingleUserShift } = useUser();
    const { restaurantId } = useAuth()

    const [validated, setValidated] = useState(false);
    const [shiftDetail, setShiftDetail] = useState({
        user_id: userId,
        clock_in: new Date(),
        clock_out: new Date(),
        restaurant_id: restaurantId
    })

    const fetchSingleUserShift = async () => {
        try {
            const shift = await getSingleUserShift(editShiftId);
            setShiftDetail({
                ...shiftDetail,
                clock_in: new Date(shift.clock_in),
                clock_out: new Date(shift.clock_out)
            });
        } catch (error) {
            console.error('Error fetching single shift', error);
        }
    };

    useEffect(() => {
        if (editMode && editShiftId) fetchSingleUserShift();
    }, [editMode, editShiftId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible && shiftDetail.clock_in && shiftDetail.clock_out && userId && restaurantId) {
                    const data = await createUserShift({ ...shiftDetail, user_id: userId, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        setShiftDetail({
                            clock_in: new Date(),
                            clock_out: new Date()
                        });
                        fetchLabourReport()
                    }
                } else if (editMode && editShiftId && shiftDetail.clock_in && shiftDetail.clock_out && restaurantId) {
                    const data = await updateUserShift(editShiftId, { ...shiftDetail, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        setShiftDetail({
                            clock_in: new Date(),
                            clock_out: new Date()
                        });
                        fetchLabourReport()
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    return (
        <div>
            <Dialog draggable={false} header={`${visible ? `Add Shift For ${userName}` : `Edit Shift For ${userName}`}`} visible={visible || (editMode && editShiftId !== null)} style={{ width: '30vw' }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className="mb-3 mt-3">
                            <div className='d-flex'>
                                <div className='w-50'>
                                    <CFormLabel>Username</CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CFormInput
                                        value={userName}
                                        disabled
                                    />
                                </div>
                            </div>
                        </CRow>
                        <CRow className="mb-3">
                            <div className='d-flex'>
                                <div className='w-50'>
                                    <CFormLabel>Clock In <span className="text-danger">*</span></CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <Calendar
                                        id="calendar-24h"
                                        value={shiftDetail.clock_in}
                                        onChange={(e) => setShiftDetail({ ...shiftDetail, clock_in: e.value })}
                                        showTime
                                        hourFormat="24"
                                        dateFormat="dd/mm/yy"
                                        className='w-100'
                                    />
                                </div>
                            </div>
                        </CRow>
                        <CRow className="mb-3">
                            <div className='d-flex'>
                                <div className='w-50'>
                                    <CFormLabel>Clock Out <span className="text-danger">*</span></CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <Calendar
                                        id="calendar-24h"
                                        value={shiftDetail.clock_out}
                                        onChange={(e) => setShiftDetail({ ...shiftDetail, clock_out: e.value })}
                                        showTime
                                        hourFormat="24"
                                        dateFormat="dd/mm/yy"
                                        className='w-100'
                                    />
                                </div>
                            </div>
                        </CRow>
                    </div>
                    <div className="d-flex p-jc-end justify-content-end button-container">
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                Submit
                            </Button>
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>)
}

export default AddUserShift